import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ldp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const LOGO_URL = "/images/logo.webp";

export const PROPERTY_IMAGES = {
  ingresso: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/7c36610l_ingresso.webp",
  ingressoAlt: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/cliqu6qz_ingresso%20vista%20balcone.webp",
  cucina: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/s8zjpqno_cucina_salone_vista%20ingresso.webp",
  cucinaAlt: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/4n0h4kie_cucina%20vista%20frontale.webp",
  cameretta: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/93652h7a_cameretta%20vista%20letti.webp",
  camerettaAlt: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/42b5shbf_cameretta%20vista%20tv.webp",
  camerettaAlt2: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/tqx54f7j_cameretta%20vista%20balcone.webp",
  camera: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/kvqodlr4_camera%20da%20letto%20vista%20quadro%20napoli.webp",
  cameraAlt: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/33rnv3bo_camera%20da%20letto%20vista%20letto.webp",
  cameraAlt2: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/20r9jnen_camera%20da%20letto%20vista%20finestra.webp",
  bagno: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/fis6ziyj_bagno%20vista%20corridoio.webp",
  bagnoAlt: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/ldi58l59_bagno%20vista%20finestra.webp",
  esterno: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/zo53rml3_LA%20DIMORA%20ESTERNI.png",
};

// Small details / thoughtful touches (welcome kit, coffee, courtesy set, art)
export const DETAIL_IMAGES = {
  welcomeKit: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/oy7pfusm_welkome%20kit%20colazione%20con%20benvenuto.webp",
  breakfast: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/x7jl5ojt_welkome%20kit%20colazione.webp",
  coffee: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/g6du1q6r_macchina%20del%20caff%C3%A8.webp",
  courtesy: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/xprr8atd_bagno%20dettaglio%20salviette.webp",
  art: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/5k8s4htg_quadro%20cuore.webp",
  slippers: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/tn7f582j_dettaglio%20ciabatte.webp",
  dispenser: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/pq6ao503_dettaglio%20dispenser%20doccia.webp",
  bidet: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/3jnx6agt_dettaglio%20bidet.webp",
  sanitized: "https://customer-assets-rejwkqb3.emergentagent.net/job_premium-retreats-3/artifacts/624zh5wd_dettaglio%20igiene%20water.webp",
};

// Placeholder atmospheric photos — Apennine mountain landscape (Abruzzo style).
// Replace with real Castel di Sangro photos when available.
export const ATMOSPHERIC_IMAGES = {
  heroTerrace: "/images/hero-castel-di-sangro-neve.webp",
  exterior: "https://customer-assets.emergentagent.com/job_premium-retreats-3/artifacts/5nzik433_neve.webp",
  entrance: "https://images.pexels.com/photos/2356045/pexels-photo-2356045.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=940",
  detail: "https://images.pexels.com/photos/2356059/pexels-photo-2356059.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
};

export const formatEUR = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", minimumFractionDigits: 0 }).format(n || 0);

export const formatDate = (s) => {
  if (!s) return "";
  const d = new Date(s);
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
};
